import { assign } from "../../helper.js";
import { isString } from "es-toolkit";
//#region ../erd-editor-schema/dist/v3/parser/word.entity.js
var createWord = () => ({
	id: "",
	name: "",
	abbreviation: "",
	englishName: "",
	description: "",
	synonyms: "",
	forbiddenWords: "",
	order: ""
});
function createAndMergeWordEntities(values) {
	const entities = {};
	for (const value of values) {
		const target = createWord();
		const assignString = assign(isString, target, value);
		assignString("id");
		assignString("name");
		assignString("abbreviation");
		assignString("englishName");
		assignString("description");
		assignString("synonyms");
		assignString("forbiddenWords");
		assignString("order");
		if (target.id) entities[target.id] = target;
	}
	return entities;
}
//#endregion
export { createAndMergeWordEntities, createWord };
